import React, { useMemo } from "react";
import "./big-event.css";

export default function CheckIn() {
  // Mock active events – replace with Firestore later
  const events = useMemo(
    () => [
      {
        id: "bb-slc-2025",
        title: "Breaking Barriers — Salt Lake City",
        checkedIn: 342,
        total: 4000,
        inPerson: 4000,
        days: 3,
        thumb:
          "https://images.unsplash.com/photo-1535916707207-35f97e715e1b?q=80&w=1200&auto=format&fit=crop",
      },
      {
        id: "naol-aug",
        title: "New Art of Living — August Tour",
        checkedIn: 128,
        total: 600,
        inPerson: 480,
        days: 1,
        thumb:
          "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?q=80&w=1200&auto=format&fit=crop",
      },
    ],
    []
  );

  const onOpenDashboard = (ev) => {
    // Store the selected event ID for the check-in dashboard
    sessionStorage.setItem("checkinEventId", ev.id);
    // TODO: Navigate to dedicated check-in dashboard page when created
    // For now, show confirmation that the event is selected
    alert(`Check-in dashboard for: ${ev.title}\n\nEvent ID: ${ev.id}\n\nReady for ticket scanning integration.`);
  };

  return (
    <div className="be-wrap">
      <div className="be-header">
        <div>
          <h2 className="be-title">Check-in</h2>
          <p className="be-subtitle">
            Pick an active event to start scanning and validating tickets.
          </p>
        </div>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
          gap: 14,
        }}
      >
        {events.map((ev) => (
          <article key={ev.id} className="be-card">
            {/* Thumb */}
            <div
              style={{
                height: 160,
                backgroundImage: `url(${ev.thumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderTopLeftRadius: 14,
                borderTopRightRadius: 14,
              }}
            />
            {/* Body */}
            <div style={{ padding: 16, background: "#fff" }}>
              <h3
                style={{
                  margin: 0,
                  textAlign: "center",
                  fontWeight: 900,
                  fontSize: 22,
                  color: "#1b1f27",
                  letterSpacing: 0.2,
                }}
              >
                {ev.title}
              </h3>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(3, 1fr)",
                  gap: 10,
                  marginTop: 14,
                }}
              >
                <div style={{ textAlign: "center" }}>
                  <div className="small muted">Checked-in</div>
                  <div style={{ color: "#22c55e", fontWeight: 800 }}>
                    {ev.checkedIn.toLocaleString()}
                  </div>
                </div>
                <div style={{ textAlign: "center" }}>
                  <div className="small muted">Total Tickets</div>
                  <div style={{ color: "#22c55e", fontWeight: 800 }}>
                    {ev.total.toLocaleString()}
                  </div>
                </div>
                <div style={{ textAlign: "center" }}>
                  <div className="small muted">In-person</div>
                  <div style={{ color: "#22c55e", fontWeight: 800 }}>
                    {ev.inPerson.toLocaleString()}
                  </div>
                </div>
              </div>

              <div
                className="muted small"
                style={{ textAlign: "center", marginTop: 8 }}
              >
                Duration: {ev.days} {ev.days > 1 ? "days" : "day"}
              </div>
            </div>

            {/* CTA */}
            <div style={{ padding: 14, background: "#f0b324" }}>
              <button
                className="gold-button"
                style={{ width: "100%" }}
                onClick={() => onOpenDashboard(ev)}
              >
                Check-in Dashboard
              </button>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
